import PropTypes from 'prop-types'
import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button'
import HOPRichTextEditor from '@/shared/components/HOPComponents/HOPRichTextEditor/HOPRichTextEditor'

import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'

import useCommunicationBoard from './useCommunicationBoard'
import { ActionsRow, FieldsColumn, NotificationsWrapper } from './styled-components'

const CommunicationBoardForm = ({ sections }) => {
  const { form, result, t } = useCommunicationBoard({ sections })

  return (
    <>
      <FieldsColumn>
        <FormControl>
          <SDSelect
            label={t('communication_board.label_section')}
            optionsList={form.sectionsOptions}
            selectedValue={form.section}
            onChangeHandler={params => form.onSectionChange(params.option?.id)}
            placeholder={t('common:choose')}
            overrides={{
              Popover: {
                props: {
                  overrides: {
                    Body: {
                      style: () => ({
                        left: '1px',
                        marginTop: '.5rem',
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        zIndex: 1000,
                      }),
                    },
                  },
                },
              },
            }}
          />
        </FormControl>
      </FieldsColumn>

      <FormControl label={t('communication_board.label_content')}>
        <HOPRichTextEditor
          id='communication-board-editor'
          value={form.content}
          onChange={form.onContentChange}
          height={240}
          withPoll={form.pollsEnabled}
        />
      </FormControl>

      <ActionsRow>
        <SDButton size={SIZE.compact} block={false} disabled={form.isSaveDisabled} onClick={form.onSave}>
          {form.isSaving ? t('common:saving') : t('common:save')}
        </SDButton>
        <SDLoader hidden={!form.isLoading} text={t('common:fetching_data')} />
      </ActionsRow>

      <NotificationsWrapper>
        <SDNotification
          type='negative'
          hidden={!(result.error && !result.message)}
          primaryText={String(result.error || '')}
        />
        <SDNotification
          type={result.error ? 'negative' : 'positive'}
          hidden={!result.message}
          primaryText={String(result.message || '')}
        />
      </NotificationsWrapper>
    </>
  )
}

CommunicationBoardForm.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string),
}

export default CommunicationBoardForm
